import { useState, useEffect } from 'react'

export default function Nav() {
  const [scrolled, setScrolled] = useState(false)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20)
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const nav = (id) => {
    setOpen(false)
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
  }

  const linkStyle = {
    fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.22em',
    textTransform: 'uppercase', color: 'rgba(0,0,0,0.35)',
    cursor: 'pointer', transition: 'color 0.2s', textDecoration: 'none',
  }
  const ctaStyle = {
    ...linkStyle, color: 'var(--pitch)',
    border: '1px solid var(--pitch)', padding: '8px 18px', borderRadius: 2,
  }

  return (
    <>
      <style>{`
        .nav-desktop { display: flex; }
        .nav-mob-btn { display: none; }
        .nav-link-item:hover { color: var(--pitch) !important; }
        .nav-link-item { position: relative; padding-bottom: 4px; }
        .nav-link-item::after { content: ''; position: absolute; bottom: 0; left: 0; width: 0; height: 1px; background: var(--pitch); transition: width 0.25s cubic-bezier(0.22,1,0.36,1); }
        .nav-link-item:hover::after { width: 100%; }
        .hamburger-bar { display: block; width: 20px; height: 1px; background: var(--pitch); transition: transform 0.3s cubic-bezier(0.22,1,0.36,1), opacity 0.2s ease; transform-origin: center; }
        .hamburger-open .hamburger-bar:nth-child(1) { transform: translateY(6px) rotate(45deg); }
        .hamburger-open .hamburger-bar:nth-child(2) { opacity: 0; transform: scaleX(0); }
        .hamburger-open .hamburger-bar:nth-child(3) { transform: translateY(-6px) rotate(-45deg); }
        .mobile-drawer { overflow: hidden; max-height: 0; transition: max-height 0.4s cubic-bezier(0.22,1,0.36,1), opacity 0.3s ease; opacity: 0; }
        .mobile-drawer.open { max-height: 300px; opacity: 1; }
        @keyframes nav-item-slide {
          from { opacity: 0; transform: translateX(-12px); }
          to { opacity: 1; transform: translateX(0); }
        }
        .mobile-drawer.open .nav-drawer-item {
          animation: nav-item-slide 0.3s cubic-bezier(0.22,1,0.36,1) both;
        }
        .mobile-drawer.open .nav-drawer-item:nth-child(1) { animation-delay: 0.05s; }
        .mobile-drawer.open .nav-drawer-item:nth-child(2) { animation-delay: 0.1s; }
        .mobile-drawer.open .nav-drawer-item:nth-child(3) { animation-delay: 0.15s; }
        .mobile-drawer.open .nav-drawer-item:nth-child(4) { animation-delay: 0.2s; }
        .nav-cta-item:hover { background: var(--pitch) !important; color: var(--bone) !important; }
        @media (max-width: 600px) {
          .nav-desktop { display: none !important; }
          .nav-mob-btn { display: flex !important; }
        }
      `}</style>

      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
        background: scrolled ? 'rgba(245,241,232,0.9)' : 'var(--bone)',
        backdropFilter: scrolled ? 'blur(10px)' : 'none',
        WebkitBackdropFilter: scrolled ? 'blur(10px)' : 'none',
        borderBottom: '1px solid rgba(0,0,0,0.08)',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        padding: '0 clamp(20px,5vw,56px)', height: 60,
        transition: 'background 0.3s ease, backdrop-filter 0.3s ease',
      }}>
        <span style={{ fontFamily: 'var(--f-d)', fontSize: 18, letterSpacing: '0.16em', cursor: 'pointer' }}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          A. Thomson
        </span>

        {/* Desktop */}
        <div className="nav-desktop" style={{ gap: 'clamp(16px,3vw,36px)', alignItems: 'center' }}>
          {[['sessions','Sessions'],['passes','Class passes']].map(([id, label]) => (
            <span key={id} className="nav-link-item" onClick={() => nav(id)} style={linkStyle}>{label}</span>
          ))}
          <a href="/testimonials" style={{ fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.18em', textTransform: 'uppercase', textDecoration: 'none', color: 'rgba(0,0,0,0.35)', transition: 'color 0.2s' }}
            onMouseEnter={e => e.target.style.color = 'var(--pitch)'}
            onMouseLeave={e => e.target.style.color = 'rgba(0,0,0,0.35)'}>
            Testimonials
          </a>
          <a href="/my-account" style={{ fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.18em', textTransform: 'uppercase', textDecoration: 'none', color: 'rgba(0,0,0,0.35)', transition: 'color 0.2s', paddingLeft: 8, borderLeft: '1px solid rgba(0,0,0,0.1)', marginLeft: 8 }}
            onMouseEnter={e => e.target.style.color = 'var(--pitch)'}
            onMouseLeave={e => e.target.style.color = 'rgba(0,0,0,0.35)'}>
            My account
          </a>
        </div>

        {/* Mobile button */}
        <button className={`nav-mob-btn${open ? ' hamburger-open' : ''}`}
          onClick={() => setOpen(o => !o)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', flexDirection: 'column', gap: 5, padding: 4 }}
          aria-label="Menu">
          <span className="hamburger-bar" />
          <span className="hamburger-bar" />
          <span className="hamburger-bar" />
        </button>
      </nav>

      {/* Mobile dropdown */}
      <div className={`mobile-drawer${open ? ' open' : ''}`} style={{
          position: 'fixed', top: 56, left: 0, right: 0, zIndex: 99,
          background: 'var(--bone)', borderBottom: '1px solid rgba(0,0,0,0.08)',
          padding: '0 32px', display: 'flex', flexDirection: 'column', gap: 20,
          paddingTop: open ? 24 : 0, paddingBottom: open ? 32 : 0,
        }}>
          {[['sessions','Sessions'],['passes','Class passes']].map(([id, label]) => (
            <span key={id} onClick={() => nav(id)}
              className="nav-drawer-item"
              style={{ ...linkStyle, color: 'var(--pitch)', fontSize: 11 }}>
              {label}
            </span>
          ))}
          <a href="/testimonials"
            className="nav-drawer-item"
            style={{ fontFamily: 'var(--f-m)', fontSize: 11, letterSpacing: '0.18em', textTransform: 'uppercase', textDecoration: 'none', color: 'var(--pitch)' }}>
            Testimonials
          </a>
          <a href="/my-account"
            className="nav-drawer-item"
            style={{ fontFamily: 'var(--f-m)', fontSize: 11, letterSpacing: '0.18em', textTransform: 'uppercase', textDecoration: 'none', color: 'var(--pitch)', paddingTop: 8, borderTop: '1px solid rgba(0,0,0,0.08)' }}>
            My account
          </a>
        </div>
    </>
  )
}
